import { render } from "./topSlider.vue?vue&type=template&id=6afee474&scoped=true"
import script from "./topSlider.vue?vue&type=script&lang=js"
export * from "./topSlider.vue?vue&type=script&lang=js"

import "./topSlider.vue?vue&type=style&index=0&id=6afee474&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6afee474"]])

export default __exports__